import { render, staticRenderFns } from "./card-detail.vue?vue&type=template&id=e0775182&scoped=true&"
import script from "./card-detail.vue?vue&type=script&lang=js&"
export * from "./card-detail.vue?vue&type=script&lang=js&"
import style0 from "./card-detail.vue?vue&type=style&index=0&id=e0775182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0775182",
  null
  
)

export default component.exports